@if (!infoSaved) {
  <div>
    <h1 mat-dialog-title>Interested in booking with us? </h1>
    <div mat-dialog-content>
      <p>Tell us about you business</p>
      <form class="flex" [formGroup]="saveBusinessInfoForm">
        <div class="flex flex-column me-4">
          <mat-form-field appearance="outline">
            <mat-label>Business Name</mat-label>
            <input matInput type="text" name="businessName" id="businessName" formControlName="businessName">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Business Contact Name</mat-label>
            <input matInput type="text" name="businessContactName" id="businessContactName" formControlName="businessContactName">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Business Contact Email</mat-label>
            <input matInput type="email" name="businessContactEmail" id="businessContactEmail" formControlName="businessContactEmail">
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Business Description</mat-label>
          <textarea matInput type="text" name="businessDescription" id="businessDescription" formControlName="businessDescription"></textarea>
        </mat-form-field>
      </form>
      <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">No Thanks</button>
        <button mat-button (click)="saveInfo()" cdkFocusInitial>Send Info</button>
      </div>
    </div>
  </div>
}
@if (infoSaved) {
  <div>
    <h1 mat-dialog-title>Thank you for getting in touch! We will be with you as soon as possible!</h1>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Close</button>
    </div>
  </div>
}
